import React, { useState } from "react";

import ProductionTodoContent from "./ProductionTodoContent";
import ProductionTodoEditContent from "./ProductionTodoEditContent";

export default function ProductionTodo({ todo }) {
	const [edit, setEdit] = useState(false);

	return (
		<>
			{!edit ? (
				<ProductionTodoContent todo={todo} setEdit={setEdit} />
			) : (
				<ProductionTodoEditContent
					todo={todo}
					onSuccess={() => setEdit(false)}
					onCancel={() => setEdit(false)}
				/>
			)}
		</>
	);
}
